import { EVENT_THEMES } from '../config/eventThemes';

// Shown on both registration and feedback pages.
// Dynamic theme colors applied via inline style — structure/spacing in App.css.
const EventInfoCard = ({ event }) => {
  const theme = EVENT_THEMES[event.theme] || EVENT_THEMES.default;
  const { info, name } = event;

  return (
    <div
      className="event-info-card"
      style={{ background: theme.bg, borderColor: theme.border }}
      aria-label={`Event information: ${name}`}
    >
      <div className="event-info-header">
        <span className="event-info-icon" aria-hidden="true">{theme.icon}</span>
        <div>
          {theme.label && (
            <span className="event-theme-label" style={{ color: theme.accent }}>
              {theme.label}
            </span>
          )}
          <h2 className="event-info-title" style={{ color: theme.accent }}>{name}</h2>
        </div>
      </div>
      <div className="event-info-details">
        <p><strong>📅</strong> {info.date}</p>
        <p><strong>💻</strong> {info.format}</p>
        <p className="event-info-description">{info.description}</p>
      </div>
    </div>
  );
};

export default EventInfoCard;